export const adminEvent = (params: { eventId: number }) => `event:${params.eventId}`;

export const adminManyTimeQuestions = (params: { organizationId: number }) => `organizationId:${params.organizationId}`;
